// 案件头部组件国际化配置 - 繁体中文
export default {
  // 元信息標籤
  creator: "創建人",
  createTime: "創建時間",
  updateTime: "更新時間",

  // 按鈕和操作
  addressMonitor: "地址監控",
  edit: "編輯",
  delete: "刪除",

  // 餘額看板
  balanceBoard: {
    title: "餘額看板-總資產餘額",
    tooltipTitle: "可在畫布中選擇地址後右鍵加入餘額看板",
    tooltipContent:
      "地址總資產餘額是將根據本系統已收錄的幣種價值，按照地址所持有的所有主幣和代幣折算成USDT得出的總餘額，幣種價值受多種因素影響變化，總資產數據僅供參考。系統當前已支持",
    supportedCurrencies: "317個幣種",
    detail: "詳情 >",
    loadingText: "拼命加載中",
  },

  // 錯誤提示
  errors: {
    loadAssetFailed: "加載資產數據失敗,請稍後重試",
    caseIdMissing: "caseInfo.id 不存在,無法獲取資產詳情",
  },
};
